<template>
  <div class="productTag">
    <span :style="{ border: `1px solid ${color}` }" class="productTag__color" v-if="color"
      ><span :style="{ backgroundColor: color }" class="productTag__colorCircle" /></span
    ><template v-if="name">{{ name }}:</template>
    <span class="productTag__text">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'ProductTag',
  props: {
    name: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.productTag {
  color: $cAddDark02;
  display: inline-block;
  font-size: 1.2rem;
  line-height: 2rem;
  text-transform: capitalize;

  &__text {
    display: inline-flex;
    font-family: $fSecond;
    font-weight: 500;
    text-transform: none;
  }

  &__color {
    position: relative;
    margin-right: 2px;
    top: -1px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }

  &__colorCircle {
    display: block;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
  }
}
</style>
